import React, { Component } from 'react';

import { avg, linReg } from '../../lib/reduce';
import { Chart } from 'react-chartjs-2';
import Metric from '../Metric';
import numeral from 'numeral';
import annotationPlugin from 'chartjs-plugin-annotation';
import html2canvas from 'html2canvas';

import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    BubbleController,
} from 'chart.js';
import GoogleFeedsModal from './GoogleFeedsModal';
import { getGoogleFeeds } from './query';
import Loading from '../Loading';
import { getLabel } from '../../helpers/date';
import { noDataMessage } from '../../helpers/noDataMessage';
import { colors, chartColors } from '../../lib/colors';
import { withTranslation } from 'react-i18next';

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    BubbleController,
    annotationPlugin,
);

const backgroundImage = new Image();
backgroundImage.src = '/static/img/google-icon.png';
const logo = new Image();
logo.src = '/static/img/gd_dash_logo-horizontal-grey֊short.png';
const logo_dark = new Image();
// logo_dark.src = '/static/img/logo-primary.svg';
logo_dark.src = '/static/img/chart_dark_logo.svg';

function uniqueByStartDate(data) {
    const seen = new Set();

    return data.filter((item) => {
        const startDate = item?.start_date?.value || item?.date?.value;
        if (!startDate) return false;

        if (seen.has(startDate)) {
            return false;
        }

        seen.add(startDate);
        return true;
    });
}

const createGradient = (ctx, chartArea, color) => {
    if (!chartArea) {
        return color.start;
    }

    const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);

    gradient.addColorStop(0, color.start);
    gradient.addColorStop(1, color.end);

    return gradient;
};

class Timeline extends Component {
    constructor() {
        super();
        this.chartRef = React.createRef();
        this.containerRef = React.createRef();
        this.hoveredLine = React.createRef();

        this.getGoogleFeeds = getGoogleFeeds;
        this.checkIsEmptyAll = this.checkIsEmptyAll.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.toogleGoogleFeeds = this.toogleGoogleFeeds.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);
        this.getNumber = this.getNumber.bind(this);
        this.downloadChartImage = this.downloadChartImage.bind(this);
        this.downloadChartImageOnlyChart = this.downloadChartImageOnlyChart.bind(this);
        this.toggleDataset = this.toggleDataset.bind(this);

        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        this.state = {
            isOpenModal: false,
            selectedItems: null,
            data: [],
            loading: true,
            isToggledGoogleFeeds: true,
            isDark: !!isDark,
            datasetIndex: null,
            isChartLegendsHidden: {},
        };
    }

    async componentDidMount() {
        if (this.props.showGoogleFeeds) {
            this.getGoogleFeeds.bind(this.setState.bind(this));
            this.getGoogleFeeds.update({ force: true });
        }

        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    downloadChartImageOnlyChart() {
        const chart = this.chartRef.current;
        if (chart) {
            const canvas = chart.canvas;

            // Create a new canvas to preserve the original
            const whiteBackgroundCanvas = document.createElement('canvas');
            whiteBackgroundCanvas.width = canvas.width;
            whiteBackgroundCanvas.height = canvas.height;

            const whiteCtx = whiteBackgroundCanvas.getContext('2d');

            // Fill the new canvas with white background
            whiteCtx.fillStyle = 'white';
            whiteCtx.fillRect(0, 0, whiteBackgroundCanvas.width, whiteBackgroundCanvas.height);

            // Draw the chart onto the white background canvas
            whiteCtx.drawImage(canvas, 0, 0);

            // Export the new canvas as JPEG
            const url = whiteBackgroundCanvas.toDataURL('image/jpeg', 1); // Quality = 1 (max)
            const link = document.createElement('a');
            link.href = url;
            link.download = this.props.header ? `${this.props.header}.jpg` : 'chart.jpg';
            link.click();
        }
    }

    toggleDataset(index) {
        const chart = this.chartRef.current;
        if (!chart) return;

        chart.setDatasetVisibility(index, !chart.isDatasetVisible(index));
        const isVisible = chart.isDatasetVisible(index);
        chart.update();
        this.setState({
            isChartLegendsHidden: {
                ...this.state.isChartLegendsHidden,
                [index]: !isVisible,
            },
        }); // Trigger re-render if needed
    }

    async downloadChartImage() {
        const container = this.containerRef.current;
        if (!container) return;

        const canvas = await html2canvas(container, {
            backgroundColor: '#ffffff',
            scale: 2,
        });

        const imgData = canvas.toDataURL('image/jpeg', 1);
        const link = document.createElement('a');
        link.href = imgData;
        link.download = this.props.header ? `${this.props.header}.jpg` : 'overview.jpg';
        link.click();
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ redraw: true, isDark });

        if (this.timeoutID) clearTimeout(this.timeoutID);

        this.timeoutID = setTimeout(() => {
            this.setState({ redraw: false });
        }, 100);
    }

    checkIsEmptyAll(list) {
        for (let element of list) {
            if (!element.classList.contains('hide-component')) return false;
        }
        return true;
    }

    onModalClose() {
        this.setState({ isOpenModal: false, selectedItems: null });
    }

    onOpenModal(items) {
        this.setState({ selectedItems: items, isOpenModal: true });
    }

    toogleGoogleFeeds() {
        this.setState({ isToggledGoogleFeeds: !this.state.isToggledGoogleFeeds, redraw: true });

        if (this.timeoutID) clearTimeout(this.timeoutID);

        this.timeoutID = setTimeout(() => {
            this.setState({ redraw: false });
        }, 100);
    }

    getNumber() {
        if (this.props.hasSecondRightAxis) return 120;
        if (this.props.hasRightAxis) return 70;
        return 20;
    }

    render() {
        const { t, customYLabelType } = this.props;
        const isDark = this.state.isDark;

        if (this.state.loading && this.props.showGoogleFeeds) {
            return <Loading />;
        }

        if (!this.props.data || !this.props.data[0]) {
            return (
                <div>
                    <div className={this.props.chartContainerStyles}>
                        <h3 className="box-header">{this.props.header ?? t('chart.overview')}</h3>
                        {/* add "chart-subtitle" class for getting same styles */}
                        {this.props.extraBox}
                    </div>
                    {this.props.customEmptyMessage || noDataMessage}
                </div>
            );
        }

        let metrics = [];
        let n = 0;

        const passedKeys = this.props.keys || Object.keys(this.props.data[0]);
        // get in descending order and change to ascending
        const passedData = [...this.props.data].sort(
            (a, b) => new Date(a?.date?.value ?? a?.date) - new Date(b?.date?.value ?? b?.date),
        );

        if (!this.props.dontShowMetrics) {
            for (let key of passedKeys) {
                if (key == 'date' || key.withoutMetric) {
                    continue;
                }

                let color = colors[n];
                let metricType = this.props.metricType;
                let icon = key.icon || '';
                let vx = passedData.map((d, i) => {
                    return i;
                });
                let vy = passedData.map((d) => {
                    return d?.[key.key || key];
                });

                let out = linReg(vx, vy);

                metrics.push(
                    <Metric
                        value={avg(passedData, key.key || key)}
                        change={out.slope}
                        metricType={metricType}
                        label={key.label || key}
                        format={key.format || '0.00a'}
                        color={color}
                        icon={icon}
                        key={key.key}
                        info={key.info}
                        img={key.img}
                    />,
                );

                n++;
            }
        }
        let executed = false;
        const onOpenModal = this.onOpenModal;
        const googleFeeds = this.state.data;
        const xAxis = this.props.xAxisKey ?? 'date';
        const showGoogleFeeds = this.props.showGoogleFeeds;

        const collectedItems = googleFeeds.reduce((acc, item) => {
            const first = new Date(passedData[0]?.[xAxis]?.value || passedData[0]?.[xAxis]);
            const end = new Date(
                passedData[passedData.length - 1]?.[xAxis]?.value ||
                    passedData[passedData.length - 1]?.[xAxis],
            );
            const date = new Date(item.date);
            const rangeItem = passedData.find((state, i, arr) => {
                const first_date = new Date(state?.[xAxis]?.value || state?.[xAxis]);
                const next_date = new Date(arr[i + 1]?.[xAxis]?.value || arr[i + 1]?.[xAxis]);
                if (date < first) {
                    return false;
                } else if (date > end) {
                    return false;
                } else if (date >= first_date && date < next_date) {
                    return true;
                }
                return false;
            });
            if (rangeItem?.date?.value) {
                acc[rangeItem?.date?.value] = acc[rangeItem?.date?.value]
                    ? [...acc[rangeItem?.date?.value], item]
                    : [item];
            }
            return acc;
        }, {});
        let arrayFromCollectedItems = [];
        for (let key in collectedItems) {
            const item = {
                date: key,
                items: collectedItems[key],
            };
            arrayFromCollectedItems.push(item);
        }

        const logoImage = {
            id: 'logoImage',
            beforeDraw(chart) {
                const { ctx } = chart;
                const paddingX = 50;
                const paddingY = 16;
                let logoWidth = 135;
                let logoHeight = 46;

                let x = ctx.canvas.width - logoWidth - paddingX;
                let y = paddingY;

                ctx.save();
                ctx.globalAlpha = 0.2;
                if (isDark) {
                    logoWidth = 135;
                    logoHeight = 27;

                    x = ctx.canvas.width - logoWidth - paddingX;
                    y = paddingY;
                    ctx.globalAlpha = 1;
                    if (logo_dark.complete) {
                        ctx.drawImage(logo_dark, x, y, logoWidth, logoHeight);
                    } else {
                        logo_dark.onload = () => chart.draw();
                    }
                } else {
                    if (logo.complete) {
                        ctx.drawImage(logo, x, y, logoWidth, logoHeight);
                    } else {
                        logo.onload = () => chart.draw();
                    }
                }
                ctx.restore();
            },
        };

        const legendMargin = {
            id: 'legendMargin',
            beforeInit(chart) {
                const fitValue = chart.legend.fit;
                chart.legend.fit = function fit() {
                    fitValue.bind(chart.legend)();
                    return (this.height += 25);
                };
            },
        };

        const googleFeedsPoints = {
            id: 'googleFeedsPoints',
            afterDatasetsDraw(chart) {
                if (!showGoogleFeeds) return;

                const {
                    ctx,
                    chartArea: { top, height },
                    scales: { x },
                } = chart;
                if (!executed) {
                    executed = true;
                    chart.canvas.addEventListener('click', handleMouseClick);
                }
                ctx.save();

                const uniquePassedDate = uniqueByStartDate(passedData);

                const feedsWithPlaces = googleFeeds
                    .map((item) => {
                        const date = new Date(item.date);
                        const oneDay = 86400000; // 1000 * 3600 * 24 - one day per miliseconds;
                        let place = 0;
                        let out = false;
                        const step =
                            (new Date(
                                uniquePassedDate[1]?.[xAxis]?.value || uniquePassedDate[1]?.[xAxis],
                            ) -
                                new Date(
                                    uniquePassedDate[0]?.[xAxis]?.value ||
                                        uniquePassedDate[0]?.[xAxis],
                                )) /
                            oneDay;

                        const first = new Date(
                            uniquePassedDate[0]?.[xAxis]?.value || uniquePassedDate[0]?.[xAxis],
                        );

                        const end = new Date(
                            uniquePassedDate[uniquePassedDate.length - 1]?.[xAxis]?.value ||
                                uniquePassedDate[uniquePassedDate.length - 1]?.[xAxis],
                        );

                        for (let i = 0; i < uniquePassedDate.length; i++) {
                            const selected_date = new Date(
                                uniquePassedDate[i]?.[xAxis]?.value || uniquePassedDate[i]?.[xAxis],
                            );

                            if (date < first || date > end) {
                                out = true;
                                break;
                            } else if (date >= selected_date) {
                                const difference =
                                    x.getPixelForValue(i + 1) - x.getPixelForValue(i);
                                const diffBetwennSelected = (date - selected_date) / oneDay;

                                place =
                                    x.getPixelForValue(i) +
                                    (difference / step) * diffBetwennSelected;
                                break;
                            }
                        }

                        return { ...item, place, out };
                    })
                    .filter((x) => !x.out);
                const newWithMergedPlaces = feedsWithPlaces.reduce((acc, curr) => {
                    for (let key in acc) {
                        if (curr.place > key - 10 && curr.place < 10 + +key) {
                            acc[key] = { place: acc[key].place, items: [...acc[key].items, curr] };
                            return acc;
                        }
                    }
                    acc[curr.place] = { place: curr.place, items: [curr] };
                    return acc;
                }, {});

                function handleMouseClick(event) {
                    if (!chart.canvas) return;
                    // Get the mouse position relative to the canvas
                    const rect = chart.canvas?.getBoundingClientRect();
                    const mouseX = event.clientX - rect?.left;
                    const mouseY = event.clientY - rect?.top;

                    // used sessionStorage to have always fresh data
                    const values = JSON.parse(sessionStorage.getItem('googleFeeds'));

                    values?.forEach((item) => {
                        if (
                            mouseX > item.place &&
                            mouseX < item.place + 18 &&
                            mouseY > top + height - 10 &&
                            mouseY < top + height + 8
                        ) {
                            onOpenModal(item?.items);
                        }
                    });
                }

                const values = Object.values(newWithMergedPlaces);
                sessionStorage.setItem('googleFeeds', JSON.stringify(values));
                values?.forEach((item) => {
                    ctx.beginPath();
                    ctx.fillStyle = 'white';
                    ctx.roundRect(item.place, top + height - 10, 18, 18, 18);
                    ctx.fill();

                    ctx.fillStyle = 'white';
                    ctx.drawImage(backgroundImage, item.place + 3, top + height - 7, 12, 12);
                });
            },
        };
        const options = {
            maintainAspectRatio: false,
            onHover: (event, elements) => {
                const chart = this.chartRef.current;
                if (!chart) return;
                if (elements.length > 0) {
                    const datasetIndex = elements[0].datasetIndex;
                    if (this.hoveredLine !== datasetIndex) {
                        this.hoveredLine = datasetIndex;
                        this.setState({
                            datasetIndex,
                        });
                    }
                } else {
                    this.hoveredLine = null;
                    this.setState({
                        datasetIndex: null,
                    });
                }
            },
            animation: false,
            scales: {
                x: {
                    stacked: this.props.stackedX ?? false,
                    grid: {
                        display: false,
                    },
                    title: {
                        display: !!this.props.xAxisTitle,
                        text: this.props.xAxisTitle,
                    },
                    ticks: {
                        color: isDark ? '#959ca5' : '#777777',
                    },
                },
                y: {
                    // stacked: true,
                    // Metrics that count upward as they get worse — average position — flip the
                    // axis so "better" still points up.
                    reverse: this.props.leftAxisReversed ?? false,
                    grid: {
                        display: false,
                    },
                    title: {
                        display: !!this.props.leftAxisLabel,
                        text: this.props.leftAxisLabel,
                    },
                    ticks: {
                        callback: function (value) {
                            return customYLabelType
                                ? customYLabelType(value)
                                : numeral(value).format('0 a');
                        },
                        color: isDark ? '#959ca5' : '#777777',
                    },
                },
            },
            interaction: {
                mode: 'nearest',
                intersect: false,
            },
            elements: {
                point: {
                    radius: 0, // default invisible point
                    hitRadius: 10, // increase clickable area
                    hoverRadius: 6, // increase area for hover effect
                },
            },
            plugins: {
                legend: {
                    align: 'start',
                    labels: {
                        color: isDark ? '#959ca5' : '#777777',
                        usePointStyle: true,
                        pointStyle: 'rect',
                        padding: 20,
                    },
                    display: !this.props.customLegends,
                },
                tooltip: {
                    callbacks: {
                        label: (context) => {
                            const percentagesValues = this.props.percentagesValues ?? [];
                            if (
                                percentagesValues.includes(context.dataset.label) ||
                                context.dataset.label.toLowerCase().includes('ctr') ||
                                this.props.showLabelAsPercentage
                            ) {
                                return `${context.dataset.label}: ${Number(context.raw).toFixed(
                                    2,
                                )} %`;
                            }
                            return `${context.dataset.label}: ${numeral(context.raw).format(
                                '0.0a',
                            )}`;
                        },
                    },
                },
            },
            radius: 0,
        };

        if (this.props.hasRightAxis) {
            options.scales.y1 = {
                display: true,
                position: 'right',

                grid: {
                    display: false,
                },
                title: {
                    display: true,
                    text: this.props.rightAxisLabel,
                },
                ticks: {
                    callback: function (value) {
                        return numeral(value).format('0 a');
                    },
                    color: isDark ? '#959ca5' : '#777777',
                },
            };
        }
        if (this.props.hasSecondRightAxis) {
            options.scales.y2 = {
                display: true,
                position: 'right',
                reverse: this.props.secondRightAxisReversed || false,
                grid: {
                    display: false,
                },
                title: {
                    display: true,
                    text: this.props.rightSecondAxisLabel,
                },
                ticks: {
                    callback: function (value) {
                        return numeral(value).format('0 a');
                    },
                    color: isDark ? '#959ca5' : '#777777',
                },
            };
        }
        if (this.props.hasLeftSecondAxis) {
            options.scales.y3 = {
                display: true,
                position: 'left',
                grid: {
                    display: false,
                },
                title: {
                    display: true,
                    text: this.props.leftSecondAxisLabel ?? '',
                },
                ticks: {
                    callback: function (value) {
                        return numeral(value).format('0 a');
                    },
                    color: this.state.isDark ? '#959ca5' : '#777777',
                },
            };
        }

        const yAxises = ['y', 'y1', 'y2', 'y3'];
        const additionalAxises =
            this.props.keys
                ?.filter((item) => item.yAxisID && !yAxises.includes(item.yAxisID))
                ?.map((x) => x.yAxisID) ?? [];
        additionalAxises?.forEach((item) => {
            options.scales[item] = {
                display: false,
                position: 'right',
                grid: {
                    display: false,
                },
            };
        });
        // If there's only one label/data point, center it by expanding the x-axis range
        const singlePoint = passedData && passedData.length === 1;
        const chartData = this.props.chartData
            ? typeof this.props.chartData === 'function'
                ? this.props.chartData(this.state.datasetIndex)
                : this.props.chartData
            : {
                  labels: passedData.map((item) =>
                      this.props.createLabels
                          ? this.props.createLabels(item)
                          : getLabel(item?.[xAxis]?.value || item?.[xAxis]),
                  ),
                  datasets: passedKeys.map((item, i) => ({
                      label: item?.label,
                      type: item.type ?? 'line',
                      data: passedData.map((data) =>
                          item.render ? item.render(data?.[item.key]) : data?.[item.key],
                      ),
                      backgroundColor: (context) => {
                          const { ctx, chartArea } = context.chart;

                          if (chartColors[i]?.start) {
                              return createGradient(ctx, chartArea, {
                                  start: `${chartColors[i].start}33`,
                                  end: `${chartColors[i].end}00`,
                              });
                          }

                          return [colors[i], colors[i]];
                      },
                      borderColor: (context) => {
                          const { ctx, chartArea } = context.chart;
                          const colorData = chartColors[i]?.start
                              ? { start: chartColors[i].start, end: chartColors[i].end }
                              : { start: colors[i], end: colors[i] };
                          const color = createGradient(ctx, chartArea, colorData);
                          return this.state.datasetIndex === null || this.state.datasetIndex === i
                              ? color
                              : 'rgba(128, 128, 128, 0.2)';
                      },

                      borderDash: item?.borderDash ?? [0],
                      yAxisID: item.yAxisID ?? 'y',
                      hidden: item.hidden ?? false,
                      borderRadius: 4,
                      tension: 0.4,
                      // If chart has only one data point, make the point visible
                      pointRadius: singlePoint ? 6 : 0,
                      pointHoverRadius: singlePoint ? 8 : 6,
                  })),
              };

        if (singlePoint) {
            options.scales.x.min = -0.5;
            options.scales.x.max = 0.5;
            // offset helps with centering labels/ticks for category scale
            options.scales.x.offset = true;
        }

        return (
            <>
                <div
                    className="Timeline"
                    ref={this.containerRef}
                    style={{
                        height: this.props.customChartSize
                            ? `${this.props.customChartSize}px`
                            : '100%',
                        minHeight: '150px',
                        position: 'relative',
                    }}
                >
                    <div className={this.props.chartContainerStyles}>
                        <h3 className="box-header">{this.props.header ?? t('chart.overview')}</h3>
                        {/* add "chart-subtitle" class for getting same styles */}
                        {this.props.extraBox}
                    </div>
                    <div className="d-flex justify-content-between align-items-end">
                        <div className="metrics mb-2">{metrics}</div>
                        <div className="dt-exports chart-action-btns">
                            {showGoogleFeeds && (
                                <div className="chart-action-btns-feeds">
                                    <span
                                        className={`switch-button mr-10 ${
                                            this.state.isToggledGoogleFeeds
                                                ? 'active'
                                                : 'not-active'
                                        }`}
                                        onClick={this.toogleGoogleFeeds}
                                        title="Show Google Feeds"
                                    >
                                        <span className="switch-circle">
                                            <img
                                                src={
                                                    this.state.isToggledGoogleFeeds
                                                        ? '/static/img/google-icon.png'
                                                        : '/static/img/google.svg'
                                                }
                                                // src={google_icon}
                                                className="google-feeds-icon"
                                                loading="lazy"
                                                alt="Google photo"
                                                title="Turn On/Off Google Update notes on Chart"
                                            />
                                        </span>
                                    </span>
                                </div>
                            )}
                            {this.props.forceRun && (
                                <button
                                    className="dt-exports__button with-refresh"
                                    type="button"
                                    onClick={this.props.forceRun}
                                    title="Refresh and clear cache"
                                >
                                    <i className="icon-Frame-converted"></i>
                                </button>
                            )}
                            <button
                                className="dt-exports__button with-refresh"
                                type="button"
                                onClick={this.downloadChartImage}
                                title="Download chart"
                            >
                                <i className="icon-fi_download"></i>
                            </button>
                            {/* <button
                                className="dt-exports__button with-refresh"
                                type="button"
                                onClick={this.downloadChartImageOnlyChart}
                                title="Download only chart"
                            >
                                <i className="icon-fi_download"></i>
                            </button> */}
                        </div>
                    </div>
                    <div
                        style={{
                            height: this.props.chartSize === 'lg' ? '400px' : '300px',
                            position: 'relative',
                        }}
                        onMouseOut={() => {
                            this.setState({
                                datasetIndex: null,
                            });
                            this.hoveredLine = null;
                        }}
                    >
                        <Chart
                            data={chartData}
                            options={options}
                            ref={this.chartRef}
                            plugins={
                                this.state.isToggledGoogleFeeds
                                    ? [googleFeedsPoints, legendMargin, logoImage]
                                    : [legendMargin, logoImage]
                            }
                            redraw={this.state.redraw}
                        />
                    </div>
                </div>
                {!this.props.loading && this.props.customLegends && (
                    <div className="d-flex justify-content-center w-100 mt-24">
                        <div className="chart-custom-legends">
                            {chartData.datasets.map((dataset, index) => {
                                const chart = this.chartRef?.current;
                                if (!chart) return null;
                                // const isVisible = chart ? chart.isDatasetVisible(index) : true;
                                const isHiddenVisible = this.state.isChartLegendsHidden[index];

                                return (
                                    <button
                                        key={dataset.label}
                                        onClick={() => this.toggleDataset(index)}
                                        style={{
                                            borderColor: dataset.borderColor,
                                            color: isHiddenVisible
                                                ? '#aaa'
                                                : isDark
                                                ? 'white'
                                                : '#000',
                                            opacity: isHiddenVisible ? 0.4 : 1,
                                            textDecoration: isHiddenVisible
                                                ? 'line-through'
                                                : 'none',
                                        }}
                                        className="chart-custom-legends-item"
                                    >
                                        <div
                                            className="chart-custom-legends-color"
                                            style={{
                                                backgroundColor: dataset.backgroundColor[0],
                                            }}
                                        ></div>
                                        {dataset.label}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}
                <GoogleFeedsModal
                    isOpen={this.state.isOpenModal}
                    onClose={this.onModalClose}
                    items={this.state.selectedItems}
                />
            </>
        );
    }
}

export default withTranslation()(Timeline);
